import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CalendlyPreference } from '@demind-inc/core';

import { integrationsApi } from '../api';

interface UseUpdateCalendlyPrefParams {
  calendlyIntegrationId: string;
  preferences: Partial<CalendlyPreference>;
}

export const useUpdateCalendlyPref = () => {
  const queryClient = useQueryClient();

  const updateCalendlyPrefMutation = useMutation({
    mutationFn: ({ calendlyIntegrationId, preferences }: UseUpdateCalendlyPrefParams) => {
      return integrationsApi
        .updateCalendlyPreference(calendlyIntegrationId, preferences)
        .then((data) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.integration.calendly'] });
    },
  });

  return {
    updateCalendlyPref: updateCalendlyPrefMutation.mutateAsync,
    ...updateCalendlyPrefMutation,
  };
};
